import React from 'react'
import BagComponent from '../../../components/Bag'

const Bag = props => {
  const { mealCount, onBagClick, lastItemInOrder } = props
  return (
    <BagComponent
      count={mealCount}
      onClick={onBagClick}
      lastItemInOrder={lastItemInOrder}
    />
  )
}

export default Bag



// WEBPACK FOOTER //
// ./src/modules/Menu/Bag/Bag.jsx